import(/* webpackMode: "eager" */ "/codebuild/output/src4103301383/src/app/home/page.tsx");
